// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-acction[data-v-de76bc2a] {\n  position: relative;\n}[dir=ltr] .header-acction[data-v-de76bc2a] {\n  float: right;\n}[dir=rtl] .header-acction[data-v-de76bc2a] {\n  float: left;\n}\n.header[data-v-de76bc2a] {\n  position: relative;\n}\n[dir=ltr] .header[data-v-de76bc2a] {\n  float: left;\n}\n[dir=rtl] .header[data-v-de76bc2a] {\n  float: right;\n}\n", ""]);
// Exports
module.exports = exports;
